"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
function Checkbox(props) {
    const { control } = (0, react_hook_form_1.useFormContext)();
    return (react_1.default.createElement(material_1.FormControlLabel, { label: props.label, labelPlacement: "start", control: react_1.default.createElement(react_hook_form_1.Controller, { name: props.name, control: control, render: ({ field }) => (react_1.default.createElement(material_1.Checkbox, Object.assign({ color: "primary" }, field, { checked: !!field.value, onChange: (event) => field.onChange({
                    target: {
                        name: name,
                        value: event.target.checked ? 1 : 0,
                    },
                }) }))) }) }));
}
exports.default = Checkbox;
